
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { ServiceProviderService } from '../../services/service-provider.service';

@Component({
  selector: 'app-service-provider-details',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './service-provider-details.component.html',
  styleUrls: ['./service-provider-details.component.css']
})
export class ServiceProviderDetailsComponent implements OnInit {
  provider: any;

  constructor(private route: ActivatedRoute, private serviceProviderService: ServiceProviderService) { }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.serviceProviderService.getServiceProviders().subscribe(data => {
        this.provider = data.find(item => item.nid === id);
      });
    }
  }
}
